import styled from 'styled-components';
import { FiSearch, FiMoreVertical } from 'react-icons/fi'; // Ícones de ação do chat

const HeaderContainer = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #202c33; /* Fundo header dark (igual sidebar header) */
  padding: 0.8rem 1rem;
  border-bottom: 1px solid #263038; /* Borda sutil dark */
`;

// Info do Contato/Agente (Logo Play Indoor + Nome Carla)
const ContactAgentInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  cursor: pointer;
`;

// Renomear para AvatarImage e manter estilo
const AvatarImage = styled.img`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  object-fit: cover;
`;

const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const ContactName = styled.h1`
  font-size: 1.1rem;
  font-weight: 500;
  color: #e9edef; /* Texto claro */
  margin: 0;
`;

const Status = styled.span`
  font-size: 0.8rem;
  color: #8696a0; /* Status claro */
`;

// Container para o logo da Play Indoor à direita
const ChatActions = styled.div`
 display: flex;
 align-items: center; // Centraliza verticalmente
 justify-content: center; // Centraliza horizontalmente DENTRO deste container
 flex-grow: 1; // Faz este container ocupar o espaço restante à direita
`;


export default function Header() {
  // Este header agora é o da coluna da direita (ChatView)
  return (
    <HeaderContainer>
      {/* Informações do contato clicado (Carla) */}
      <ContactAgentInfo>
        {/* Usar AvatarImage com a URL do pravatar */}
        <AvatarImage src="https://i.pravatar.cc/150?img=38" alt="Avatar Carla" />
        <ContactInfo>
          <ContactName>Carla Lendária</ContactName>
          <Status>online</Status>
        </ContactInfo>
      </ContactAgentInfo>

      {/* Ações específicas do chat */}
       <ChatActions>
          {/* Recolocar logo da Play Indoor */}
          <img src="https://lirp.cdn-website.com/81bc62d1/dms3rep/multi/opt/Logo+Play+Indoor-2x-1920w.png" alt="Logo Play Indoor" height="28" title="Play Indoor"/>
          {/* Ícones de busca e menu removidos */}
       </ChatActions>
    </HeaderContainer>
  );
}
